import React from 'react';
import Helmet from 'react-helmet';
import { Loading } from '../app/components';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import PropertyCreate from './PropertyCreate';

const PropertyCreatePage = ({ viewer, location, creatingProperty, creatingPropertyDone }) => {
  if (creatingPropertyDone) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: '/createProperty' },
        }}
      />
    );
  }

  if (creatingProperty) {
    return <Loading loading loadingColor="#ffffff" backgroundColor="#00E39A" />;
  }

  if (!viewer) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: '/' },
        }}
      />
    );
  }

  return (
    <div>
      <Helmet title="Ný eign - Húsfinnur" />
      <PropertyCreate location={location} />
    </div>
  );
};

PropertyCreatePage.propTypes = {
  viewer: React.PropTypes.object,
  location: React.PropTypes.any,
  creatingProperty: React.PropTypes.bool.isRequired,
  creatingPropertyDone: React.PropTypes.bool.isRequired,
};

export default
  connect(
    state => ({
      viewer: state.users.viewer,
      creatingProperty: state.properties.creatingProperty,
      creatingPropertyDone: state.properties.creatingPropertyDone,
    }),
)(PropertyCreatePage);



// WEBPACK FOOTER //
// ./src/browser/propertyCreate/PropertyCreatePage.js